import React from 'react';
import { LocationStepContent } from './steps/location/Content';
import { DetailStepContent } from './steps/detail/Content';
import { MapStepContent } from './steps/map/Content';
import { ReviewStepContent } from './steps/review/Content';
import { ReadingStepContent } from './steps/reading/Content';
import { InventorizeStep } from './components/store';
import { FloorplanStepContent } from './steps/floorplan/Content';
import { NotFoundContent } from '../not_found/components/NotFoundContent';

export const renderContentByStep = (newStep: InventorizeStep): React.FC => {
  switch (newStep) {
    case InventorizeStep.LocationStep:
      return LocationStepContent;
    case InventorizeStep.ReadingStep:
      return ReadingStepContent;
    case InventorizeStep.MapStep:
      return MapStepContent;
    case InventorizeStep.FloorplanStep:
      return FloorplanStepContent;
    case InventorizeStep.DetailStep:
      return DetailStepContent;
    case InventorizeStep.ReviewStep:
      return ReviewStepContent;
    default:
      return NotFoundContent;
  }
};
